module.exports = __webpack_public_path__ + "pc-static/img/1.79cd999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.jpg
// module id = Erzt
// module chunks = 1